import AMapLoader from '@amap/amap-jsapi-loader';
export default function MapLoader () { // <-- 原作者这里使用的是module.exports
    return new Promise((resolve, reject) => {
        if (window.AMap) {
            resolve(window.AMap)
        } else {
            AMapLoader.load({
                "key": "89d266d11730bc0017e39be726bc4985",              // 申请好的Web端开发者Key，首次调用 load 时必填
                "version": "1.4.15",   // 指定要加载的 JS API 的版本，缺省时默认为 1.4.15
                "plugins": ["AMap.Autocomplete","AMap.Geolocation","AMap.PlaceSearch","AMap.Driving","AMap.Transfer","AMap.Walking","AMap.Riding"],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
                "AMapUI": {             // 是否加载 AMapUI，缺省不加载
                    "version": '1.1',   // AMapUI 版本
                    "plugins":['overlay/SimpleMarker'],       // 需要加载的 AMapUI ui插件
                }
            }).then((AMap)=>{
                    resolve(AMap)
                }
            ).catch((e)=>{
                    reject(e)
                }
            )
        }
    })
}
